import {login} from '../../api/system'
import {getLoginUser, updateLoginUserAvatar} from '../../api/user'
import {TENANT_ID, TOKEN} from '../../constant/index'
import {setItem, getItem, removeItem} from '../../utils/cookie'
import {reqGetInfo, reqLogin} from "../../api/system/users";

const user = {
    namespaced: true,
    state: {
        // 用户token
        token: getItem(TOKEN),
        // 当前操作租户ID（超级管理员可切换；普通用户=登录租户）
        tenantId: getItem(TENANT_ID),
        // 用户角色
        roles: '',
        // 用户头像
        avatar: '',
        // 用户昵称
        nickname: '',
        // 登录时间
        loginTime: '',
        // 登录IP
        ipAddress: '',
        // IP属地
        ipLocation: '',
        type:'',
        id:'',
        // 用户自身所属租户（用于判断是否超级管理员，不随切换而改变）
        selfTenantId:'',
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_TENANT_ID(state, tenantId) {
            state.tenantId = tenantId
        },
        SET_ROLES(state, roles) {
            state.roles = roles
        },
        SET_AVATAR(state, avatar) {
            state.avatar = avatar
        },
        SET_NICK(state, nickname) {
            state.nickname = nickname
        },
        SET_LOGIN_TIME(state, loginTime) {
            state.loginTime = loginTime
        },
        SET_IP_ADDRESS(state, ipAddress) {
            state.ipAddress = ipAddress
        },
        SET_IP_LOCATION(state, ipLocation) {
            state.ipLocation = ipLocation
        },
        SET_USER_TYPE(state, type) {
            state.type = type
        },
        SET_ID(state, type) {
            state.id = type
        },
        SET_SELF_TENANT_ID(state, tenantId) {
            state.selfTenantId = tenantId
        }
    },
    // 异步处理方式
    actions: {
        /**
         * 用户登录
         */
        login({commit}, loginForm) {
            // 调用登录方法，在获取到数据后向外传递
            return new Promise((resolve, reject) => {
                reqLogin(loginForm).then((data) => {
                    // 设置token值
                    commit('SET_TOKEN', data)
                    setItem(TOKEN, data)
                    // 记住登录时选择的租户
                    commit('SET_TENANT_ID', loginForm.tenantId)
                    setItem(TENANT_ID, loginForm.tenantId)
                    resolve()
                }).catch((error) => {
                    // 如果出现登录异常的情况将其捕获并抛出
                    reject(error)
                })
            })
        },
        /**
         * 获取用户信息
         */
        getUserInfo({commit}) {
            return new Promise((resolve, reject) => {
                // 获取用户信息
                reqGetInfo().then(res => {
                    // 存储用户信息
                    const user = res
                    const avatar = (user.avatar === '' || user.avatar === null) ? require('@/assets/images/background.jpg') : user.avatar
                    commit('SET_AVATAR', avatar)
                    // 设置当前用户角色到Vuex中
                    commit('SET_ROLES', user.roles)
                    // 设置当前用户昵称到Vuex中
                    commit('SET_NICK', user.nickname)
                    // 设置登录时间
                    commit('SET_LOGIN_TIME', user.loginTime)
                    // 设置登录IP
                    commit('SET_IP_ADDRESS', user.ipAddress)
                    // 设置IP属地
                    commit('SET_IP_LOCATION', user.ipLocation)
                    commit('SET_USER_TYPE', user.type)
                    commit('SET_ID',user.id);
                    // 记录用户自身所属租户（判断是否超级管理员）
                    if (user.tenantId) {
                        commit('SET_SELF_TENANT_ID', user.tenantId)
                    }
                    resolve(user)
                }).catch((error) => {
                    // 如果出现登录异常的情况将其捕获并抛出
                    reject(error)
                })
            })
        },
        /**
         * 更新用户头像
         *
         * @param {*} param0
         * @param {*} avatarForm 用户头像表单
         */
        updateAvatar({commit}, avatarForm) {
            return new Promise((resolve, reject) => {
                // 更新用户头像信息
                const {userId, src} = avatarForm
                updateLoginUserAvatar({userId, src}).then((res) => {
                    // 更新用户头像（返回内容为用户新头像的访问路径）
                    commit('SET_AVATAR', res)
                    resolve(res)
                }).catch((error) => {
                    // 如果出现更新异常的情况将其捕获并抛出
                    reject(error)
                })
            })
        },
        /**
         * 退出登录
         *
         * @param {*} param0
         */
        logout({commit}) {
            // 清除Token
            removeItem(TOKEN)
            // 清除租户
            removeItem(TENANT_ID)
            // 清除用户角色数据
            commit('SET_ROLES', '')
            commit('SET_TENANT_ID', '')
        }
    }
}

export default user
